/* Aromatick homepage redesign (ah-*): size pills, tabs, ship countdown. Add-to-cart uses the theme's own <product-form>. */
(function () {
  if (window.__ahHome) return;
  window.__ahHome = true;

  // Size pills: swap variant id, price and availability inside the card.
  document.addEventListener("click", function (e) {
    var pill = e.target.closest(".ah-size");
    if (!pill) return;
    var card = pill.closest("[data-ah-card]");
    if (!card) return;
    card.querySelectorAll(".ah-size").forEach(function (p) { p.setAttribute("aria-pressed", p === pill ? "true" : "false"); });
    var now = card.querySelector(".ah-price__now"), was = card.querySelector(".ah-price__was");
    if (now) now.textContent = pill.dataset.price;
    if (was) { was.textContent = pill.dataset.compare || ""; was.hidden = !pill.dataset.compare; }
    var input = card.querySelector('input[name="id"]');
    if (input) input.value = pill.dataset.variant;
    var btn = card.querySelector(".ah-add");
    if (btn) {
      var ok = pill.dataset.available === "true";
      btn.disabled = !ok;
      btn.textContent = ok ? btn.dataset.label : btn.dataset.soldout;
    }
  });

  // Tabs
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-ah-tab]");
    if (!tab) return;
    var root = tab.closest("[data-ah-tabs]");
    root.querySelectorAll("[data-ah-tab]").forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
    root.querySelectorAll("[data-ah-panel]").forEach(function (p) { p.hidden = p.dataset.ahPanel !== tab.dataset.ahTab; });
  });

  // Countdown to a ship/launch date
  function countdowns(scope) {
    (scope || document).querySelectorAll("[data-ah-count]").forEach(function (el) {
      var d = new Date(el.dataset.ahCount);
      if (isNaN(d)) { el.hidden = true; return; }
      var days = Math.ceil((d - new Date()) / 864e5), out = el.querySelector("b");
      if (days <= 0) { el.hidden = true; return; }
      el.hidden = false;
      out.textContent = days === 1 ? "1 day" : days + " days";
    });
  }
  countdowns();
  document.addEventListener("shopify:section:load", function (e) { countdowns(e.target); });
})();
